import loader from "../../../assets/images/Spinner2.svg";
import "./Button.css";

const Button = ({
  onSubmit = () => {},
  label,
  labelStyle,
  type,
  className = "",
  disabled,
  pre_icon,
  post_icon,
  post_icon_class,
  pre_icon_class,
  id,
  isLoading,
  fontSize = "text-lg",
}) => {
  return (
    <button
      id={id}
      disabled={!!disabled}
      type={type}
      onClick={onSubmit}
      className={`button flex items-center justify-center bg-[#55C6EF] hover:bg-[#55C6EF] disabled:bg-gray-400 disabled:cursor-not-allowed opacity-100  ${className}`}
    >
      <div className="flex gap-2 items-center">
        {pre_icon && (
          <span className={pre_icon_class}>
            <img src={pre_icon} alt="" />
          </span>
        )}
        {isLoading ? (
          <span className="h-[24px] w-[24px] loader flex items-center justify-center">
            <img className="h-full w-full" src={loader} alt="loader" />
          </span>
        ) : (
          <span
            className={`text-[#1A2024] text-center ${fontSize} not-italic font-semibold leading-6 tracking-[-0.18px] content-start rtl:text-right ${labelStyle}`}
          >
            {label}
          </span>
        )}
      </div>
      {post_icon && !isLoading && (
        <span>
          <img src={post_icon} alt="" className={post_icon_class} />
        </span>
      )}
    </button>
  );
};

export default Button;
